<template>
    <v-container max-width="100%" style="margin-top: 2%;">
        <template>
            <v-row justify="center">
                <v-dialog v-model="confirmDialog" persistent max-width="500">
                    <v-card>
                        <v-card-title class="headline">
                            <span style="color: #d60000">{{ $t('system.alert') }}</span>
                        </v-card-title>
                        <v-card-text>
                            <span style="color: #d60000">{{ this.mensagemdialog }}</span>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{
                                $t('button.dismiss') }}</v-btn>
                            <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text"
                                @click="deleteFromDatabase">{{ $t('button.confirm') }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <merus-data-table :headers="headers" :items="turnos" :mostrar-inativos="mostrarInativos" :loading="loadingtable"
            :default-multi-sort="defaultSort" :loading-text="$t('turnos.loading')" @update:displayedItems="displayedItemsForExport = $event"

 cod-tabela="TURNOSPASSAGEIROS" @update:headers="headers = $event">
            <template v-slot:toolbar>
                <CadastroToolbar :title="$t('turnosPassageiros.title')" :token="token" :items="displayedItemsForExport !== null ? displayedItemsForExport : turnosFiltrados" :csv-title="$t('turnosPassageiros.title')"
                    :pdf-title="$t('turnosPassageiros.title')" :pdf-headers="headers" :pdf-filename="$t('turnosPassageiros.title')" hide-search
                    :endpoint-upload-csv="canEdit || canInsert ? '/api/v1.0/processacsvturnospassageiros/' : null" @saveBulk="saveBulk"
                    :help-dialog-csv-fields="helpCSV" :help-dialog-csv-model="$t('turnosPassageiros.title')" :csv-headers="headersCSV">
                    <template v-slot:extension>
                        <v-switch
                            v-model="mostrarInativos"
                            :label="$t('crudVeiculos.showInactive')"
                            class="ml-3 mr-4"
                            hide-details
                        ></v-switch>
                    </template>
                    <template v-slot:add v-if="canInsert">
                        <v-dialog v-model="dialog" max-width="80%">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            <v-card>
                                <v-toolbar dark color="primary" ref="myToolbar">
                                    <v-btn icon dark @click="close">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                    <v-toolbar-title>{{ $tc('turnosPassageiros.self', 1) }}</v-toolbar-title>
                                </v-toolbar>

                                <v-card-text>
                                    <v-container>
                                        <v-form ref="form" v-model="formValidado">
                                            <v-row>
                                                <v-col cols="12" sm="6" md="2">
                                                    <v-text-field v-model="editedItem.cod_turno" :label="$t('turnosPassageiros.headers.code')"
                                                        :rules="[(v) => !!v || $t('rules.messageName')]"></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="6" md="3">
                                                    <v-text-field v-model="editedItem.descricao_turno"
                                                        :label="$t('turnosPassageiros.headers.description')"
                                                        :rules="[(v) => !!v || $t('rules.messageName')]"></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="6" md="2">
                                                    <v-select v-model="editedItem.id_unidade" :items="unidades" item-text="cod_unidade"
                                                        item-value="id_unidade" auto clearable :label="$t('turnosPassageiros.headers.unit')"></v-select>
                                                </v-col>

                                                <v-col cols="12" sm="6" md="3">
                                                    <v-text-field v-model="editedItem.cod_integracao_erp" :label="$t('turnosPassageiros.headers.integrationCode')"></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="6" md="2">
                                                    <v-switch v-model="editedItem.ativo" :label="$t('turnosPassageiros.headers.active')"></v-switch>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="2" md="2">
                                                    <span style="font-weight: bold;">{{ $t('turnosPassageiros.headers.validMonday') }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_entrada_segunda" :label="$t('turnosPassageiros.arrivalTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_saida_segunda" :label="$t('turnosPassageiros.departureTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="2" md="2">
                                                    <span style="font-weight: bold;">{{ $t('turnosPassageiros.headers.validTuesday') }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_entrada_terca" :label="$t('turnosPassageiros.arrivalTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_saida_terca" :label="$t('turnosPassageiros.departureTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="2" md="2">
                                                    <span style="font-weight: bold;">{{ $t('turnosPassageiros.headers.validWednesday') }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_entrada_quarta" :label="$t('turnosPassageiros.arrivalTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_saida_quarta" :label="$t('turnosPassageiros.departureTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="2" md="2">
                                                    <span style="font-weight: bold;">{{ $t('turnosPassageiros.headers.validThursday') }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_entrada_quinta" :label="$t('turnosPassageiros.arrivalTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_saida_quinta" :label="$t('turnosPassageiros.departureTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="2" md="2">
                                                    <span style="font-weight: bold;">{{ $t('turnosPassageiros.headers.validFriday') }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_entrada_sexta" :label="$t('turnosPassageiros.arrivalTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_saida_sexta" :label="$t('turnosPassageiros.departureTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="2" md="2">
                                                    <span style="font-weight: bold;">{{ $t('turnosPassageiros.headers.validSaturday') }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_entrada_sabado" :label="$t('turnosPassageiros.arrivalTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_saida_sabado" :label="$t('turnosPassageiros.departureTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="2" md="2">
                                                    <span style="font-weight: bold;">{{ $t('turnosPassageiros.headers.validSunday') }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_entrada_domingo" :label="$t('turnosPassageiros.arrivalTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_saida_domingo" :label="$t('turnosPassageiros.departureTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn dark color="primary" @click="close">{{ $t('button.cancel') }}</v-btn>
                                    <v-btn dark color="primary" @click="save">{{ $t('button.save') }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </template>
                </CadastroToolbar>

            </template>

            <template v-slot:item.valido_segunda="{ item }">
                <v-icon v-if="item.ativo == 0" color="grey">mdi-minus</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_segunda == 1" color="green">mdi-check</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_segunda == 0" color="red">mdi-close</v-icon>
            </template>
            <template v-slot:item.valido_terca="{ item }">
                <v-icon v-if="item.ativo == 0" color="grey">mdi-minus</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_terca == 1" color="green">mdi-check</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_terca == 0" color="red">mdi-close</v-icon>
            </template>
            <template v-slot:item.valido_quarta="{ item }">
                <v-icon v-if="item.ativo == 0" color="grey">mdi-minus</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_quarta == 1" color="green">mdi-check</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_quarta == 0" color="red">mdi-close</v-icon>
            </template>
            <template v-slot:item.valido_quinta="{ item }">
                <v-icon v-if="item.ativo == 0" color="grey">mdi-minus</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_quinta == 1" color="green">mdi-check</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_quinta == 0" color="red">mdi-close</v-icon>
            </template>
            <template v-slot:item.valido_sexta="{ item }">
                <v-icon v-if="item.ativo == 0" color="grey">mdi-minus</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_sexta == 1" color="green">mdi-check</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_sexta == 0" color="red">mdi-close</v-icon>
            </template>
            <template v-slot:item.valido_sabado="{ item }">
                <v-icon v-if="item.ativo == 0" color="grey">mdi-minus</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_sabado == 1" color="green">mdi-check</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_sabado == 0" color="red">mdi-close</v-icon>
            </template>
            <template v-slot:item.descricao_turno="{ item }">
                <span>{{ translateShiftDescription(item.descricao_turno) }}</span>
            </template>
            <template v-slot:item.valido_domingo="{ item }">
                <v-icon v-if="item.ativo == 0" color="grey">mdi-minus</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_domingo == 1" color="green">mdi-check</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_domingo == 0" color="red">mdi-close</v-icon>
            </template>
            <template v-slot:item.ativo="{ item }">
                <span>{{ item.ativo == 1 ? $t('selectOptions.yes') : $t('selectOptions.no') }}</span>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" color="green" @click="editItem(item)" :disabled="!canEdit">mdi-pencil</v-icon>
                <v-icon small class="mr-2" color="red" @click="deleteItem(item)" :disabled="!canDelete">mdi-delete</v-icon>
                <!-- <v-icon small class="mr-2" color="red" @click="deleteItem(item)">mdi-delete</v-icon> -->
            </template>
        </merus-data-table>
    </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import EventBus from "../utils/eventBus";
import translatePassengerShiftDescription from "@/utils/translatePassengerShift";

export default {
    components: {
        MerusDataTable,
        CadastroToolbar
    },
    data: () => ({
    headers: [],
        turnos: [],
        mostrarInativos: false,
        displayedItemsForExport: null,
        search: "",
        loadingtable: true,
        tipoAlerta: "success",
        showAlert: false,
        mensagemAlerta: "",
        confirmDialog: false,
        mensagemdialog: "",
        showConfirmButton: true,
        authDialog: false,
        formValidado: true,
        dialog: false,
        sysError: null,
        editedIndex: -1,
        operacao: 0,
        editedItem: {
            id_turno: null,
            cod_turno: null,
            descricao_turno: null,
            horario_entrada_segunda: null,
            horario_saida_segunda: null,
            horario_entrada_terca: null,
            horario_saida_terca: null,
            horario_entrada_quarta: null,
            horario_saida_quarta: null,
            horario_entrada_quinta: null,
            horario_saida_quinta: null,
            horario_entrada_sexta: null,
            horario_saida_sexta: null,
            horario_entrada_sabado: null,
            horario_saida_sabado: null,
            horario_entrada_domingo: null,
            horario_saida_domingo: null,
            ativo: null,
            cod_integracao_erp: null,
            id_unidade: null,
        },
        deletedItem: {
            id_turno: null,
            cod_turno: null,
            descricao_turno: null,
            horario_entrada_segunda: null,
            horario_saida_segunda: null,
            horario_entrada_terca: null,
            horario_saida_terca: null,
            horario_entrada_quarta: null,
            horario_saida_quarta: null,
            horario_entrada_quinta: null,
            horario_saida_quinta: null,
            horario_entrada_sexta: null,
            horario_saida_sexta: null,
            horario_entrada_sabado: null,
            horario_saida_sabado: null,
            horario_entrada_domingo: null,
            horario_saida_domingo: null,
            ativo: null,
            cod_integracao_erp: null,
            id_unidade: null,
        },
        defaultItem: {
            id_turno: null,
            cod_turno: null,
            descricao_turno: null,
            horario_entrada_segunda: null,
            horario_saida_segunda: null,
            horario_entrada_terca: null,
            horario_saida_terca: null,
            horario_entrada_quarta: null,
            horario_saida_quarta: null,
            horario_entrada_quinta: null,
            horario_saida_quinta: null,
            horario_entrada_sexta: null,
            horario_saida_sexta: null,
            horario_entrada_sabado: null,
            horario_saida_sabado: null,
            horario_entrada_domingo: null,
            horario_saida_domingo: null,
            ativo: null,
            cod_integracao_erp: null,
            id_unidade: null,
        },
        recursos: [],
        unidades: [],
        canInsert: false,
        canEdit: false,
        canDelete: false,
    }),
    computed: {
        turnosFiltrados() {
            if (!this.mostrarInativos) {
                return this.turnos.filter((t) => t.ativo === true || t.ativo === 1);
            }
            return this.turnos;
        },
        defaultSort() {
            return [
                { value: 'cod_turno', options: { text: this.$t('turnos.increasing'), value: 1 } }]
        },
        headersCSV() {
            return [
                { text: this.$t('csv.lineNumber'), value: 'line_number', error: 'error_line' },
                { text: this.$t('turnosPassageiros.csv.operacao'), value: 'operacao' },
                { text: this.$t('turnosPassageiros.headers.code'), value: 'cod_turno' },
                { text: this.$t('turnosPassageiros.headers.description'), value: 'descricao_turno' },
                { text: this.$t('turnosPassageiros.headers.unit'), value: 'cod_unidade' },
                { text: this.$t('turnosPassageiros.headers.integrationCode'), value: 'cod_integracao_erp' },
                { text: this.$t('turnosPassageiros.headers.active'), value: 'ativo' },
                { text: this.$t('turnosPassageiros.csv.horarioEntradaSegunda'), value: 'horario_entrada_segunda' },
                { text: this.$t('turnosPassageiros.csv.horarioSaidaSegunda'), value: 'horario_saida_segunda' },
                { text: this.$t('turnosPassageiros.csv.horarioEntradaTerca'), value: 'horario_entrada_terca' },
                { text: this.$t('turnosPassageiros.csv.horarioSaidaTerca'), value: 'horario_saida_terca' },
                { text: this.$t('turnosPassageiros.csv.horarioEntradaQuarta'), value: 'horario_entrada_quarta' },
                { text: this.$t('turnosPassageiros.csv.horarioSaidaQuarta'), value: 'horario_saida_quarta' },
                { text: this.$t('turnosPassageiros.csv.horarioEntradaQuinta'), value: 'horario_entrada_quinta' },
                { text: this.$t('turnosPassageiros.csv.horarioSaidaQuinta'), value: 'horario_saida_quinta' },
                { text: this.$t('turnosPassageiros.csv.horarioEntradaSexta'), value: 'horario_entrada_sexta' },
                { text: this.$t('turnosPassageiros.csv.horarioSaidaSexta'), value: 'horario_saida_sexta' },
                { text: this.$t('turnosPassageiros.csv.horarioEntradaSabado'), value: 'horario_entrada_sabado' },
                { text: this.$t('turnosPassageiros.csv.horarioSaidaSabado'), value: 'horario_saida_sabado' },
                { text: this.$t('turnosPassageiros.csv.horarioEntradaDomingo'), value: 'horario_entrada_domingo' },
                { text: this.$t('turnosPassageiros.csv.horarioSaidaDomingo'), value: 'horario_saida_domingo' }];
        },
        helpCSV() {
            return [
                { label: this.$t('turnosPassageiros.headers.code'), description: this.$t('turnosPassageiros.csv.helpCode'), example: 'T1', key: 'cod_turno' },
                { label: this.$t('turnosPassageiros.headers.description'), description: this.$t('turnosPassageiros.csv.helpDescricao'), example: 'Turno manhã', key: 'descricao_turno' },
                { label: this.$t('turnosPassageiros.headers.unit'), description: this.$t('turnosPassageiros.csv.helpCodUnidade'), example: 'UN001', key: 'cod_unidade' },
                { label: this.$t('turnosPassageiros.headers.integrationCode'), description: this.$t('turnosPassageiros.csv.helpCodIntegracao'), example: '', key: 'cod_integracao_erp' },
                { label: this.$t('turnosPassageiros.headers.active'), description: this.$t('turnosPassageiros.csv.helpAtivo'), example: '1', key: 'ativo' },
                { label: this.$t('turnosPassageiros.csv.horarioEntradaSegunda'), description: this.$t('turnosPassageiros.csv.helpHorariosDesc'), example: '08:00;17:00', key: 'horario_entrada_segunda' },
                { label: this.$t('turnosPassageiros.csv.horarioSaidaSegunda'), description: this.$t('turnosPassageiros.csv.helpHorariosDesc'), example: '08:00;17:00', key: 'horario_saida_segunda' },     
                { label: this.$t('turnosPassageiros.csv.horarioEntradaTerca'), description: this.$t('turnosPassageiros.csv.helpHorariosDesc'), example: '08:00;17:00', key: 'horario_entrada_terca' },
                { label: this.$t('turnosPassageiros.csv.horarioSaidaTerca'), description: this.$t('turnosPassageiros.csv.helpHorariosDesc'), example: '08:00;17:00', key: 'horario_saida_terca' },
                { label: this.$t('turnosPassageiros.csv.horarioEntradaQuarta'), description: this.$t('turnosPassageiros.csv.helpHorariosDesc'), example: '08:00;17:00', key: 'horario_entrada_quarta' },
                { label: this.$t('turnosPassageiros.csv.horarioSaidaQuarta'), description: this.$t('turnosPassageiros.csv.helpHorariosDesc'), example: '08:00;17:00', key: 'horario_saida_quarta' },
                { label: this.$t('turnosPassageiros.csv.horarioEntradaQuinta'), description: this.$t('turnosPassageiros.csv.helpHorariosDesc'), example: '08:00;17:00', key: 'horario_entrada_quinta' },
                { label: this.$t('turnosPassageiros.csv.horarioSaidaQuinta'), description: this.$t('turnosPassageiros.csv.helpHorariosDesc'), example: '08:00;17:00', key: 'horario_saida_quinta' },
                { label: this.$t('turnosPassageiros.csv.horarioEntradaSexta'), description: this.$t('turnosPassageiros.csv.helpHorariosDesc'), example: '08:00;17:00', key: 'horario_entrada_sexta' },
                { label: this.$t('turnosPassageiros.csv.horarioSaidaSexta'), description: this.$t('turnosPassageiros.csv.helpHorariosDesc'), example: '08:00;17:00', key: 'horario_saida_sexta' },
                { label: this.$t('turnosPassageiros.csv.horarioEntradaSabado'), description: this.$t('turnosPassageiros.csv.helpHorariosDesc'), example: '08:00;17:00', key: 'horario_entrada_sabado' },
                { label: this.$t('turnosPassageiros.csv.horarioSaidaSabado'), description: this.$t('turnosPassageiros.csv.helpHorariosDesc'), example: '08:00;17:00', key: 'horario_saida_sabado' },
                { label: this.$t('turnosPassageiros.csv.horarioEntradaDomingo'), description: this.$t('turnosPassageiros.csv.helpHorariosDesc'), example: '08:00;17:00', key: 'horario_entrada_domingo' },
                { label: this.$t('turnosPassageiros.csv.horarioSaidaDomingo'), description: this.$t('turnosPassageiros.csv.helpHorariosDesc'), example: '08:00;17:00', key: 'horario_saida_domingo' }];
        },
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        }
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.populaRecursos();
        this.populaUnidades();
    },
    methods: {
        translateShiftDescription(text) {
            return translatePassengerShiftDescription(text, this.$i18n.locale);
        },

        populaRecursos() {
            if (this.user.is_superadmin === 1) {
                apiController.request(apiController.endpoints.getallRecursos, {
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.canEdit = true;
                        this.canInsert = true;
                        this.canDelete = true;
                        this.initialize();
                    },
                });
            } else {
                apiController.request(apiController.endpoints.getRecursosusuario, {
                    params: { id: this.user.id_usuario },
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updateturnopassageiro");
                        this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/insertturnopassageiro");
                        this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deleteturnopassageiro");
                        this.initialize();
                    },
                });
            }
        },
        populaUnidades() {
            apiController.request(apiController.endpoints.getallUnidadesativas, {
                onSuccess: (response) => {
                    this.unidades = response.data;
                },
            });
        },
        initialize() {
            apiController.request(apiController.endpoints.getallTurnospassageiros, {
                silent: true,
                onSuccess: (response) => {
                    this.turnos = response.data;
                    this.loadingtable = false;
                },
                onError: (e) => {
                    console.log(e);
                    this.sysError = e;
                    this.authDialog = true;
                },
            });
        },
        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.deletedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        editItem(item) {
            this.editedIndex = this.turnos.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.operacao = 1;
            this.dialog = true;
        },
        deleteItem(item) {
            this.deletedItem = Object.assign({}, item);
            this.operacao = 2;
            this.mensagemdialog = this.$t('turnos.deleteTurno') + ` ${this.deletedItem.descricao_turno}?`
            this.messageConfirmButton = this.$t('button.delete');
            this.messageDismissButton = this.$t('button.cancel');
            this.showConfirmButton = true;
            this.confirmDialog = true;
        },
        deleteFromDatabase() {
            apiController.request(apiController.endpoints.deleteTurnopassageiro, {
                    data: this.deletedItem,
                    onSuccess: (response) => {
                        this.updateTable(response.data.erro);
                        this.confirmDialog = false;
                    },
                    onError: () => {
                        this.confirmDialog = false;
                    },
                });
            },
            save(){
                this.$refs.form.validate();
                if (this.formValidado) {
                    if (this.editedItem.horario_entrada_segunda == "") {
                        this.editedItem.horario_entrada_segunda = null;
                    }
                    if (this.editedItem.horario_entrada_terca == "") {
                        this.editedItem.horario_entrada_terca = null;
                    }
                    if (this.editedItem.horario_entrada_quarta == "") {
                        this.editedItem.horario_entrada_quarta = null;
                    }
                    if (this.editedItem.horario_entrada_quinta == "") {
                        this.editedItem.horario_entrada_quinta = null;
                    }
                    if (this.editedItem.horario_entrada_sexta == "") {
                        this.editedItem.horario_entrada_sexta = null;
                    }
                    if (this.editedItem.horario_entrada_sabado == "") {
                        this.editedItem.horario_entrada_sabado = null;
                    }
                    if (this.editedItem.horario_entrada_domingo == "") {
                        this.editedItem.horario_entrada_domingo = null;
                    }

                    if (this.editedIndex == -1) {
                        this.operacao = 0;

                    apiController.request(apiController.endpoints.insertTurnopassageiro, {
                        data: this.editedItem,
                        onSuccess: (response) => {
                            this.updateTable(response.data.erro);
                        },
                    });
                } else {
                    this.operacao = 1;
                    apiController.request(apiController.endpoints.updateTurnopassageiro, {
                        data: this.editedItem,
                        onSuccess: (response) => {
                            this.updateTable(response.data.erro);
                        },
                    });
                }
            }
        },
        updateTable(status) {
                let mensagem = "";
                let tipo = status ? "error" : "success";
                
            if (status) {
                if (this.operacao == 0) {
                    mensagem = this.$t('turnos.alerts.error.insert');
                } else {
                    if (this.operacao == 1) {
                        mensagem = this.$t('turnos.alerts.error.update');
                    } else {
                        mensagem = this.$t('turnos.alerts.error.delete');
                    }
                    }
                } else {
                    if (this.operacao == 0) {
                    mensagem = this.$t('turnos.alerts.success.insert');
                    } else {
                    if (this.operacao == 1) {
                        mensagem = this.$t('turnos.alerts.success.update');
                    } else {
                        mensagem = this.$t('turnos.alerts.success.delete');
                    }
                    }
                }
                
                EventBus.$emit('show-alert', { mensagem, tipo });
                this.close();
                this.initialize();
            },
        saveBulk(result) {
            apiController.request(apiController.endpoints.upsertTurnospassageirosbulk, {
                data: result,
                onSuccess: (response) => {
                    this.updateTable(response.data.erro);
                },
            });
        },
        },
    }
</script>

